<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Reporte de Visita Domiciliaria
      <q-space />
      <q-btn flat round color="primary" icon="print" @click="exportarPDF()" />
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
            <q-input  filled  dense   label="Nombre del Paciente" />
        </div>
        <div class="col-4">
            <q-input  filled  dense   label="Edad" />
        </div>
        <div class="col-4">
            <q-input  filled  dense   label="Hombre" />
        </div>
        <div class="col-4">
            <q-input  filled  dense   label="Estado Civil" />
        </div>
        <div class="col-12">
            <q-input  filled  dense   label="Grado de Estudio" />
        </div>
        <div class="col-12">
            <q-input  filled  dense   label="Domicilio" />
        </div>
        <div class="col-12">
            <q-input  filled  dense   label="Localidad" />
        </div>
        <div class="col-12">
            <q-input autogrow filled  dense   label="Motivo de la Consulta" />
        </div>
        <div class="col-12">
            <q-input autogrow filled  dense   label="Resultado" />
        </div>
        <div class="col-12">
            <q-input autogrow filled  dense   label="Observaciones" />
        </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { computed, onBeforeMount } from "vue";
import axios from "axios";
import { generarVisitaDomiciliaria } from "../PDF/VisitaDomiciliariaPDF.js";
import { Notify, useQuasar, QSpinnerFacebook } from "quasar";
const $q = useQuasar();
const store = useStore();

const paciente = computed({
  get: () => store.state.pacienteStore,
  set: (val) => (store.state.pacienteStore = val),
});

async function exportarPDF() {
  await generarVisitaDomiciliaria(paciente.value);
}
</script>
